import { createReducer } from 'utils/reduxUtils';
import set from 'lodash/fp/set';
import get from 'lodash/fp/get';
import flow from 'lodash/fp/flow';
import {
  MEMBERSHIP_FETCH_FAIL,
  MEMBERSHIP_FETCH_START,
  MEMBERSHIP_FETCH_SUCCESS,
  MEMBERSHIP_SET_PRODUCT_FAIL,
  MEMBERSHIP_SET_PRODUCT_START,
  MEMBERSHIP_SET_PRODUCT_SUCCESS,
} from './actionTypes';
import initialState from './initialState';

const reducerToActionTypeMap = {
  [MEMBERSHIP_FETCH_START]: set('isLoading', true),
  [MEMBERSHIP_FETCH_SUCCESS]: (state, { payload } = {}) =>
    flow(
      set('isLoading', false),
      set('memberSince', get('member_since', payload)),
      set(
        'numberOfProductBoughtSinceLastUnlock',
        get('number_of_product_bought_since_last_unlock', payload)
      ),
      set('numberOfPendingSelectionProducts', get('number_of_pending_selection_products', payload)),
      set('currentSelectedFreeProduct', get('current_selected_free_product', payload)),
      set('freeProductCatalog', get('free_product_catalog', payload))
    )(state),
  [MEMBERSHIP_FETCH_FAIL]: set('isLoading', false),
  [MEMBERSHIP_SET_PRODUCT_START]: set('isLoading', true),
  [MEMBERSHIP_SET_PRODUCT_SUCCESS]: (state, { payload } = {}) =>
    flow(
      set('isLoading', false),
      set('currentSelectedFreeProduct', get('current_selected_free_product', payload))
    )(state),
  [MEMBERSHIP_SET_PRODUCT_FAIL]: set('isLoading', false),
};

export default createReducer(reducerToActionTypeMap, initialState);
